import { useContext, useEffect } from 'react';
import Navbar from './Navbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { sentryLog } from '../Utils/SentryLog';
import { UserContext } from '../Context/UserContext';
import SignupSuccess from '../Components/SignupSuccess';
import FooterComponent from '../Common/FooterComponent';
import SheetsAddonUseCases from './SheetsAddonUseCases';
import SheetsAddonFAQ from './SheetsAddonFAQ';
// Core Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Required Swiper CSS files
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
// Swiper modules (Arrows and Dots)
import { Navigation, Pagination } from 'swiper/modules';
import WhyThisAddon from './WhyThisAddon';
import SlidesHomeNavbar from './SlidesHomeNavbar';
import SlidesFooterComponent from '../Common/SlidesFooterComponent';

function SlidesHome() {

  const { user } = useContext(UserContext);

  const isUserLoggedIn = user ? true : false;

  const isShowConsole = process.env.NODE_ENV === 'development';

  const location = useLocation();
  const navigate = useNavigate();

  const API_BASE_URL = process.env.NODE_ENV === 'development' 
    ? process.env.REACT_APP_LOCAL_API_URL 
    : process.env.REACT_APP_API_URL;

  useEffect(() => {
    document.title = "Convert PDF to Google Slides in 1 click | PDF to Google Slides Converter";
  }, []);

  useEffect(() => {
    if((user !== undefined) && isUserLoggedIn){
      
    }
  }, [user]);

  const initiateLogin = async () => {
    try{
        await fetch(`${API_BASE_URL}/api/session-init`, {
            method: 'GET',
            credentials: 'include'
          });
        const currentPath = `${window.location.pathname}${window.location.search}`;
        window.location.href = `${API_BASE_URL}/auth/google?state=${encodeURIComponent(currentPath)}`;
    }catch(err){
        isShowConsole && console.error('error in initiate login method of Sheets Extension: ', err);
        sentryLog(`Sheets Extension Home.js - initiateLogin failed: ${err?.message || err}`);
    }
  }

  return (
    <div className='parentDiv'>
      {
        <>
          <div className='mainDiv newUser sheetsExtension'>
            <div className="heroSection" style={{width: '90%'}}>
              <SlidesHomeNavbar isNewUser={true}/>     
              <div className='intro'>
                <div className='introWrapper'>
                  <h1 className='headline'>Convert PDF to Google Slides in 1 click!</h1>
                  <h2 className='sub-headline'>
                    Convert PDF pages to Editable, presentation ready slides
                    <br/>
                    Directly inside Google Slides
                  </h2>
                  <div className='sheetsExtensionDemoContainer'>
                    <div className='wrapper'>
                        <h3 className='caption'>1-click conversion directly inside Google Slides</h3>
                        <Swiper
                          modules={[Navigation, Pagination]}
                          spaceBetween={50}
                          slidesPerView={1}
                          navigation={true}
                          pagination={{ clickable: true }}
                          className="demoCarousel"
                          style={{ width: '100%', maxWidth: '90vw', outline: 'solid 2px #0F9D58', borderRadius: '16px' }}
                        >
                          {/* Slide 1: Your existing YouTube Video */}
                          <SwiperSlide>
                            <iframe 
                              src="https://www.youtube.com/embed/LswCnRxRHHY?si=H-tWlWYfM43lBdhI" 
                              className='demoVideo'
                              title="How to Convert PDF to Google Slides in 1 Click With Layout Intact (2026)" 
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" 
                              allowFullScreen>
                            </iframe>
                          </SwiperSlide>

                          {/* Slide 2: A placeholder for your future screenshot */}
                          <SwiperSlide>
                            <img className='demoVideo' src='pdf-to-google-slides-converter-preview.png' alt="screenshot showing how to convert a pdf page to editable slide directly inside google slides"/>
                          </SwiperSlide>
                          
                        </Swiper>
                    </div>
                  </div>
                  <div className='ctaContainer'>
                    <div className='wrapper'>
                      {/* <p className='trustTxt'>Trusted by 500+ professionals and businesses worldwide</p> */}
                      <div className='ctaDiv'>
                        <div className='ctaBtn'>
                          <a href="https://workspace.google.com/marketplace/app/convert_pdf_to_google_slides/496987605713" target="_blank" rel="noopener">
                            Try for free
                          </a>
                        </div>
                      </div>
                      {/* <div className='extensionLink'>
                        <div className='startCtaTxt'>
                          <div>Try for free 👉</div>
                          <div className='subtxt'>get started in a minute</div>
                        </div>
                        <a href="https://workspace.google.com/marketplace/app/table_invoice_ocr_for_google_sheets/687083288287?pann=b" target="_blank" aria-label="Get it from the Google Workspace Marketplace" rel="noopener noreferrer">
                          <img className="marketplace-badge" alt="Google Workspace Marketplace badge" src="https://workspace.google.com/static/img/marketplace/en/gwmBadge.svg?"/>
                        </a>
                      </div>
                      <p className='infoTxt'>Google Workspace Marketplace and the Google Workspace Marketplace logo are trademarks of Google LLC.</p> */}
                        {/* {(user !== undefined) && !isUserLoggedIn && <div className='loginDiv' onClick={initiateLogin}>
                          <div className='loginBtn'>
                            Try for free
                          </div>
                        </div>}
                        <p className='infoTxt'>Featured on the Google Workspace Marketplace - More Secure and Compliant Solution for Business documents</p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='sheetsAddonUseCases'>
            <SheetsAddonUseCases/>
          </div>
          <div className='sheetsAddonWhyThisApp'>
            <WhyThisAddon/>
          </div>
          <div className='sheetsAddonFAQ'>
            <SheetsAddonFAQ/>
          </div>
          <div className='partnerBadges'>
            <a href="https://wired.business" target="_blank">
              <img src="https://wired.business/badge0-dark.svg" alt="Featured on Wired Business" width="200" height="54"/>
            </a>
          </div> */}
          <SlidesFooterComponent fromSheetsExtensionHomePage={true}/>
        </>
      }
      {/* {(user !== undefined) && isUserLoggedIn &&
        <>
          <SignupSuccess/>
        </>
      } */}
    </div>
  );
}

export default SlidesHome;
